module.exports = __webpack_public_path__ + "static/media/Lato-Light.2fe27d9d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-Light.ttf
// module id = 298
// module chunks = 0